module.exports = ".less-rule-import2 {\n  background: lightgreen;\n}\n.less-rule-import1 {\n  background: lightgreen;\n  background-image: url(\"folder/url.js\");\n}\n.less-rule-direct {\n  background: lightgreen;\n}\n"


/*****************
 ** WEBPACK FOOTER
 ** (webpack)/~/raw-loader!(webpack)/~/less-loader!./loaders/less-loader/less/stylesheet.less
 ** module id = 1
 ** module chunks = 0
 **/